// @flow

import _ from 'lodash';
import ApiObject from '../ApiObject';
import User from './User';

export default class UsersList extends ApiObject {
  users: Array<User> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize users
    this.users = [];
    const _this = this;

    // -- handle the case were the api responds a json with the array directly.
    let dataUsers = [];
    if (!_.isUndefined(data.users)) {
      dataUsers = data.users;
    } else {
      dataUsers = data;
    }

    _.each(dataUsers, (userData: Object) => {
      const user:User = new User();
      user.fromJson(userData);
      _this.users.push(user);
    });
  }


  findById(idToFind: string): ?User {
    const found = _.find(this.users, (user: User): boolean => {
      return user.id === idToFind;
    });

    if (_.isUndefined(found)) {
      return null;
    }

    return found;
  }
}
